// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index.js'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import Vuex from 'vuex'
import axios from 'axios'
import qs from 'qs'

Vue.use(Vuex)
Vue.config.productionTip = false

Vue.use(ElementUI)

const store = new Vuex.Store({
  state: {
    iscollapse: false,
    doLoading: false
  },
  mutations: {
    change_iscollapse: function (state) {
      state.iscollapse = !state.iscollapse
    }
  }
})
Vue.prototype.$store = store

//axios
Vue.prototype.$axios = axios


let cancel, promiseArr = {}
const CancelToken = axios.CancelToken;
// //请求拦截器
// axios.interceptors.request.use(config => {
//   //发起请求时，取消掉当前正在进行的相同请求
//   if (promiseArr[config.url]) {
//     promiseArr[config.url]('操作取消')
//     promiseArr[config.url] = cancel
//   } else {
//     promiseArr[config.url] = cancel
//   }
//   return config
// }, error => {
//   return Promise.reject(error)
// })

// //响应拦截器即异常处理
// axios.interceptors.response.use(response => {
//   return response
// }, err => {
//   if (err && err.response) {
//     switch (err.response.status) {
//       case 400:
//         err.message = '错误请求'
//         break;
//       case 401:
//         err.message = '未授权，请重新登录'
//         break;
//       case 403:
//         err.message = '拒绝访问'
//         break;
//       case 404:
//         err.message = '请求错误,未找到该资源'
//         break;
//       case 405:
//         err.message = '请求方法未允许'
//         break;
//       case 408:
//         err.message = '请求超时'
//         break;
//       case 500:
//         err.message = '服务器端出错'
//         break;
//       case 501:
//         err.message = '网络未实现'
//         break;
//       case 502:
//         err.message = '网络错误'
//         break;
//       case 503:
//         err.message = '服务不可用'
//         break;
//       case 504:
//         err.message = '网络超时'
//         break;
//       case 505:
//         err.message = 'http版本不支持该请求'
//         break;
//       default:
//         err.message = `连接错误${err.response.status}`
//     }
//   } else {
//     err.message = "连接到服务器失败"
//   }
//   message.err(err.message)
//   return Promise.resolve(err.response)
// })

// if (process.env.NODE_ENV != "development") {
//   axios.defaults.baseURL = "http://127.0.0.1:9999";
// }
// else {
//   axios.defaults.baseURL = "http://127.0.0.1:9999";
// }
// console.log(axios.defaults.baseURL);

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = `token ${store.state.token}`;
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  });

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    return response;
  },
  error => {
    if (error.response.status) {
      // console.log(error.response.status);

      switch (error.response.status) {
        case 401:
          // store.commit(types.LOGOUT);

          // 返回 401 清除token信息并跳转到登录页面
          // router.replace({
          //   path: '/login',
          //   query: { redirect: router.currentRoute.fullPath }
          // });
          router.replace({ name: "Login" });

        case 504:
          router.replace({ name: "Login" });
      }
    }
    return Promise.reject(error.response.data)   // 返回接口返回的错误信息
  });

// axios.defaults.baseURL = '/api'
// 设置默认请求头
// axios.defaults.headers = {
//   'X-Requested-With': 'XMLHttpRequest',
//   // "Access-Control-Allow-Origin": '*',
//   // 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
// }
axios.defaults.timeout = 10000


//post
Vue.prototype.$doPost = function (url, data) {
  return new Promise((resolve) => {
    Vue.prototype.$store.state.doLoading = true;
    // var loading = Vue.prototype.$loading({ fullscreen: true })
    axios.post(url, data)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => alert(err))
    // loading.close();
    Vue.prototype.$store.state.doLoading = false;
  })

}

//get
Vue.prototype.$doGet = (url) => {
  return new Promise((resolve) => {
    axios.get(url)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => alert(err))
  })
}

//end axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (store.state.token) {  // 通过vuex state获取当前的token是否存在
      next();
    }
    else {
      next({
        path: '/login',
        query: { redirect: to.fullPath }  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else {
    next();
  }
})


// WEBPACK FOOTER //
// ./src/main.js